import { serverHost } from "variables/serverdata";

// Fetch the single proxy for a site
export const getProxy = async (site_uuid) => {
    const res = await fetch(`${serverHost}/hrms/proxy/by_site/${site_uuid}`);
    if (!res.ok) {
        if (res.status === 404) return null;
        throw new Error("Failed to fetch proxy");
    }
    return res.json();
};

// Register (or get) the proxy for a site
export const registerProxy = async (site_uuid, proxyData = {}) => {

    const client_uuid = localStorage.getItem("clientId");

    const res = await fetch(`${serverHost}/hrms/proxy/register`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
            site_uuid,
            client_uuid,
            ...proxyData
        }),
    });

    const data = await res.json().catch(() => ({}));

    if (!res.ok) {
        throw new Error(data.error || "Failed to register proxy");
    }

    return data;
};

// Update proxy metadata (NOT site_uuid)
export const updateProxy = async (proxy_uuid, proxyData) => {
    const res = await fetch(`${serverHost}/hrms/proxy/${proxy_uuid}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(proxyData),
    });

    const data = await res.json().catch(() => ({}));

    if (!res.ok) {
        throw new Error(data.error || "Failed to update proxy");
    }

    return data;
};

// Fetch current site from localStorage
export const getSite = () => {
    const site = JSON.parse(localStorage.getItem("selectedSite")) || {};
    return {
        site_uuid: site.site_uuid || null,
    };
};